import * as R from 'ramda';
import { isBlank } from '@trs/utils';
import * as actions from '../actions/types';

const initialState = {
  list: [],
  totalResults: 0,
  redirect: false,
  fetchingList: true,
  errors: [],
  bannerMessage: '',
  filterOptions: [],
};

export default function rolesReducer(state = initialState, action) {
  switch (action.type) {
    case actions.ROLES_REQUESTED: {
      return {
        ...state,
        fetchingList: true,
      };
    }

    case actions.ROLES_GET: {
      let list = [];

      const { data } = action.response;

      const filterOptions = R.map(
        item => ({
          title: item.key,
          key: item.key,
          list: item.options,
        }),
        data.filterOptions || []
      );

      if (!isBlank(data)) {
        list = data.roles.map(item => ({
          ...item,
          name: item.name,
          menuListProps: {
            delete: {
              disabled: !item.isEditable,
            },
          },
        }));
      }

      return {
        ...state,
        list,
        filterOptions,
        fetchingList: false,
        totalResults: isBlank(data.count) ? 0 : data.count,
      };
    }
    default:
      return state;
  }
}
